import axios from "axios";
import { Urls } from "../../urls";

export const getJobOpeningsRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_JOB_OPENING_LIST_API,
    params: params,
  });
};

export const postJobOpeningsRepo = (data) => {
  return axios({
    method: "POST",
    url: Urls.POST_JOB_OPENING_LIST_API,
    data: data,
  });
};

export const putJobOpeningRepo = (jobId, data) => {
  return axios({
    method: "PUT",
    url: `${Urls.POST_JOB_OPENING_LIST_API}/${jobId}`,
    data: data,
  });
};

export const getFilteredDataRepo = (params) => {
  return axios({
    method: "GET",
    url: Urls.GET_JOB_OPENING_FILTER_API,
    params: params,
  });
};

export const deleteJobDataRepo = (jobId) => {
  return axios({
    method: "DELETE",
    url: `${Urls.DELETE_JOB_OPENING_LIST_API}/${jobId}`,
  });
};

export const getJobDetailRepo = (jobId) => {
  return axios({
    method: "GET",
    url: `${Urls.GET_JOB_OPENING_LIST_API}/${jobId}`,
  });
};
